/**
 * @title preferences.js: Sub-module for Account pages
 * @description This module is used to handle account preferences tasks
 * @dependency
 */
define(['utilityGlobal', 'membershipHelper', 'memberVerification'], function(util, membershipHelper, verification) {
  let Preferences = {
    /**
     * Initialization of the module.
     */
    init: function() {
      verification.init();
      this.clearNotification();
      // @TODO MembershipMetaData chooses which URL to use to get the membership
      // meta data. If its a citiCardRequest, use this one. This might be
      // appropriate in the membership-data.js.getMembershipData
      //
      // Preferences.ajaxHandler(COSTCO.util.makeUrl(
      //   '/AjaxCitiMembershipMetaDataView', {
      //     pseudo: new Date().getTime(),
      //   }), null);
    },
    /**
     * When you select a preference checkbox, this function will remove any
     * success or error messages that may be at the top of the page.
     * @return {void}
     */
    clearNotification: function() {
      $('#CommunicationPrefForm input[type=checkbox]').unbind('click').on('click', function() {
        $('#notification-message').removeClass();
        $('#notification-message').children().remove();
      });
    },
    /**
     * Grab the communication preferences from the server. This is invoked
     * by the renderMarketing function when a user switches between their
     * WCS and CRM emails.
     * @return {jQuery.Deferred} The promise to be chained to the calling
     *                               function.
     */
    getCommunicationPreferences: function() {
      return COSTCO.util.ajax({
        url: '/MemberCommunicationPreferencesRetrieveCmd',
        type: 'POST',
        dataType: 'json',
        data: $('#CommunicationPrefForm').serialize(),
      });
    },
    /**
     * This is a wrapper to setting the user's preferences. By default it will
     * call /MemberCommunicationPreferencesRetrieveCmd to grab this data. This
     * service returns an array representing the marketing data. Passing true
     * indicates that we want to call getMembershipData
     * (/AjaxMembershipMetaDataView) to grab this marketing data which has a
     * slightly different data structure.
     * @param  {Boolean} isMemetaDataResp If we're calling this function
     * @return {void}
     */
    renderMarketing: function(isMemetaDataResp) {
      var emailData = $('#comm_prefs_email_dropdown').val();
      $('#email').val(emailData);
      isMemetaDataResp
        ? membershipHelper.getMembershipData().done((data) => {
          this.setInputs(data);
        })
        : this.getCommunicationPreferences().done((data) => {
          this.setInputs(data);
        });
    },
    /**
     * Actually sets the preferences inputs using the values returned from
     * whichever service response we retreive.
     * @param  {Array|Object} data The data to use to set inputs. Array if
     *                             from /MemberCommunicationPreferencesRetrieveCmd
     *                             Object if /AjaxMembershipMetaDataView
     * @return {void}
     */
    setInputs: function(data) {
      let marketingArr = Array.isArray(data) ?
        data : data.caller && data.caller.marketing ?
        data.caller.marketing : [];
      marketingArr.forEach((mkt) => {
        let key = mkt.name.value;
        let value = mkt.value.value;
        let id;
        switch (key) {
          case 'THIRDPARTYINFORMATIONSHARING':
            id = 'receivePromoAndMarketingMaterialsThirdParty';
            this.checkBox(id, value);
            break;
          case 'COSTCOMAILANDCOUPONS':
            id = 'receivePromosAndMarketingMail';
            this.radioButton(value);
            break;
          case 'EMAILCONTACT':
            id = 'receivePromosAndMarketingEMail';
            this.radioButton(value);
            break;
          case 'TEXTMSGALERT':
            id = 'receivePromosAndMarketingTextMsg';
            this.checkBox(id, value);
            break;
          case 'COSTCOCONNECTION':
            id = 'receiveCostcoConnectionMail';
            this.checkBox(id, value);
            break;
          case 'DIGITALCOSTCOCONNECTION':
            id = 'receiveCostcoConnectionDigital';
            this.checkBox(id, value);
            break;
          case 'TOBACCOSHARING':
            id = 'receiveTobacco';
            this.checkBox(id, value);
            break;
          case 'PRODUCTRECOMMEND':
            id = 'showProdRecommend';
            this.checkBox(id, value);
            break;
          default:
            void(0);
        }
      });
    },
    /**
     * Special handling for setting the appropritate checkboxes.
     * @param  {String} id    The id of the input we're checking
     * @param  {String} value The value 'YES', 'NO', comes from the service
     *                        response and is interpreted to mean check/unchecked
     * @return {void}
     */
    checkBox: function(id, value) {
      if (typeof value != 'undefined' && value.toUpperCase() == 'YES') {
        $(`[name=${id}]`).prop('checked', true);
      } else {
        $(`[name=${id}]`).prop('checked', false);
      };
    },
    radioButton: function(value){
      if(typeof value != 'undefined' && value.toUpperCase() == 'YES') {
        $(`[id=receivePromosAndMarketingEMail]`).prop('checked', true);
        $(`[id=receivePromosAndMarketingEMail2]`).prop('checked', false);
      } else {
        $(`[id=receivePromosAndMarketingEMail2]`).prop('checked', true);
        $(`[id=receivePromosAndMarketingEMail]`).prop('checked', false);
      };
    },
    unCheckRadioOptIn: function() {
      $(`[id=receivePromosAndMarketingEMail]`).prop('checked', false);
    },
    unCheckRadioOptOut: function() {
      $(`[id=receivePromosAndMarketingEMail2]`).prop('checked', false);
    },
    /**
     * The hanlder on the 'update preferences' button that saves the users
     * preferences that they checked.
     * @return {jQuery.Deferred} The chainable promise.
     */
    saveData: function() {
      console.log('Entering CommunicationPrefWidget.saveData');
      return COSTCO.util.ajax({
          type: 'POST',
          // dataType: 'json',
          url: COSTCO.util.makeUrl('/MemberCommunicationPreferencesUpdateCmd', {
            membershipNumber: $('input[name=membershipNumber]').val(),
            langId: wcs.langId,
            storeId: wcs.storeId,
            catalogId: wcs.catalogId,
          }),
          data: $('#CommunicationPrefForm').serialize(),
        })
        .done((dataResponse) => {
          if (dataResponse == null || dataResponse == '' || !JSON.parse(dataResponse).error) {
        	  util.notification.displayNotification(util.notification.type.SUCCESS, [messages.COMMUNICATION_PREFERENCES_SUCCESS_MESSAGE]);
          } else {
            let notifications = [];
            JSON.parse(dataResponse).errorMessages.forEach(function(element) {
              if (!notifications.includes(element)) {
                notifications.push(element);
              }
            });
            //notifications.push(messages.COMMUNICATION_PREFERENCES_ERROR_MESSAGE);
            if (notifications.includes(messages._ERR_GENERIC_CRM_DOWN)) {
            	notifications = [messages._ERR_GENERIC_SAVE_COMMUNICATION_PREFERENCES];
            }
            util.notification.displayNotification(util.notification.type.ERROR, notifications);
          }
        })
        .fail((x, t, m) => {
        	util.notification.displayNotification(util.notification.type.ERROR, [messages.COMMUNICATION_PREFERENCES_ERROR_MESSAGE]);
          if (t === 'timeout') {
            console.log('Session timed out.');
          } else {
            console.log('Couldn\'t update preferences.');
          }
        });
    },
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.Preferences = Preferences;
  return Preferences;
});



// WEBPACK FOOTER //
// ./js/account/preferences.js